import { createReducer, createAsyncThunk } from '@reduxjs/toolkit';

import { RaByPublisherOrRetailer } from '../types';
import { RootState } from '.';
import { chicoryFetcher, fetchUrlFormatter, getValidPubs } from '../utils';

const initialRaByPublisher: RaByPublisherOrRetailer = [];

export const fetchRaByPublisher = createAsyncThunk<
  RaByPublisherOrRetailer,
  number,
  { state: RootState }
>('FETCH_RA_BY_PUBLISHER', async (limit, { getState }) => {
  const state = getState();

  const pubs = getValidPubs({
    selectedPubs: state.pubs.selectedPubs,
    availablePubs: state.pubs.availablePubs,
  });
  const path = '/reporting/ra/publisher';

  try {
    if (state.dateRange.from === null || state.dateRange.to === null) {
      throw new Error('Date range in store is unexpectedly null.');
    }
    const data = await chicoryFetcher(
      fetchUrlFormatter({
        path: path,
        from: state.dateRange.from,
        to: state.dateRange.to,
        pubs: pubs,
        limit: limit,
      })
    ).then((response) => response.json());
    return data;
  } catch (error) {
    console.error('fetchRaByPublisher error.', error);
  }
});

export const raByPublisherReducer = createReducer<RaByPublisherOrRetailer>(
  initialRaByPublisher,
  (builder) => {
    builder.addCase(fetchRaByPublisher.fulfilled, (state, action) => {
      return action.payload;
    });
  }
);
